document.addEventListener('DOMContentLoaded', async () => {
  const LOCAL_STORAGE_KEY = 'shopify-wishlist';
  const wishlistGrid = document.getElementById('wishlist-grid');
  const emptyMsg = document.getElementById('wishlist-empty');
  
  // 1. HELPER: Get Wishlist from Storage
  const getWishlist = () => JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEY)) || [];
  
  // 2. HELPER: Save Wishlist to Storage
  const saveWishlist = (handles) => localStorage.setItem(LOCAL_STORAGE_KEY, JSON.stringify(handles));

  // 3. LOGIC: Toggle Item (Add/Remove)
  const toggleWishlist = (handle, btn) => {
    let wishlist = getWishlist();
    const index = wishlist.indexOf(handle);
    
    if (index === -1) {
      wishlist.push(handle);
      btn.classList.add('active');
      btn.querySelector('.wishlist-icon').style.fill = 'black';
    } else {
      wishlist.splice(index, 1);
      btn.classList.remove('active');
      btn.querySelector('.wishlist-icon').style.fill = 'none';
    }
    
    saveWishlist(wishlist);
  };

  // 4. LOGIC: Initialize Buttons on Product Cards
  const initButtons = () => {
    const buttons = document.querySelectorAll('.wishlist-btn');
    const wishlist = getWishlist();
    
    buttons.forEach(btn => {
      const handle = btn.dataset.productHandle;
      if (wishlist.includes(handle)) {
        btn.classList.add('active');
        btn.querySelector('.wishlist-icon').style.fill = 'black';
      }
      
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        toggleWishlist(handle, btn);
      });
    });
  };

  // 5. PAGE LOAD: If we are on the Wishlist Page
  if (wishlistGrid) {
    const wishlist = getWishlist();
    
    if (wishlist.length === 0) {
      wishlistGrid.style.display = 'none';
      emptyMsg.style.display = 'block';
    } else {
      wishlistGrid.innerHTML = '';

      // MutationObserver: Button anzeigen sobald Karten geladen sind
      const addAllBtn = document.getElementById('wishlist-add-all-btn');
      if (addAllBtn) {
        const observer = new MutationObserver(() => {
          const hasItems = wishlistGrid.children.length > 0
            && !wishlistGrid.querySelector('.wishlist-loading');
          addAllBtn.style.display = hasItems ? 'block' : 'none';
        });
        observer.observe(wishlistGrid, { childList: true, subtree: true });
      }

      // Fetch product cards using Section Rendering API
      const requests = wishlist.map(handle => 
        fetch(`/products/${handle}?section_id=wishlist-card-render`)
          .then(res => res.text())
          .then(html => {
            const parser = new DOMParser();
            const doc = parser.parseFromString(html, 'text/html');
            const content = doc.querySelector('.wishlist-grid-item'); 
            if (content) return content.innerHTML;
            return '';
          })
      );

      const items = await Promise.all(requests);
      wishlistGrid.innerHTML = items.join('');
      
      initButtons();
    }
  } else {
    initButtons();
  }
});